module.exports = __webpack_public_path__ + "static/media/fcrf.7e55eb28.png";